﻿window.cDateNbReservationService = function (bddRef, dat, dataReservationService) {

    this.dataReservationService = dataReservationService
    this.lstDataReservationHebergement = []
    this.date = dat

    this.mGetNbAdulteTot = function () {
        var nbAdulte = 0
        this.lstDataReservationHebergement.forEach(function (dataResaHeberg) {
            nbAdulte += dataResaHeberg.nb_adulte
        })
        return nbAdulte
    }

    this.mGetNbEnfantTot = function () {
        var nbEnfant = 0
        this.lstDataReservationHebergement.forEach(function (dataResaHeberg) {
            nbEnfant += dataResaHeberg.nb_enfant
        })
        return nbEnfant
    }

    this.mGetQteCompare = function () {
        var qteDetail = 0
        switch (parseInt(dataReservationService.id_type_quantite)) {
            case 0: //saisie
                qteDetail = dataReservationService.qte +"u"
                break;
            case 1://nbadulte
                qteDetail = this.mGetNbAdulteTot() + "a"
                break;
            case 2://nbenfant
                qteDetail = this.mGetNbEnfantTot() + "e"
                break;
            case 3://nbadulte+nbenfant
                qteDetail = this.mGetNbAdulteTot() + "a" + this.mGetNbEnfantTot() + "e"
                break;
        }
        return qteDetail
    }

    this.mGetQte = function () {
        var qte = 0
        switch (parseInt(dataReservationService.id_type_quantite)) {
            case 0: //saisie
                qte = dataReservationService.qte
                break;
            case 1://nbadulte
                qte = this.mGetNbAdulteTot()
                break;
            case 2://nbenfant
                qte = this.mGetNbEnfantTot()
                break;
            case 3://nbadulte+nbenfant
                qte = this.mGetNbAdulteTot() + this.mGetNbEnfantTot()
                break;
        }
        return qte
    }

    this.mGetTotTtc = function () {
        return this.mGetQte() * dataReservationService.puttc
    }
}